// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m-2A","label":"styles_label__3cslS"};